module.exports = __webpack_public_path__ + "static/media/darkTheme.f861874e.jpg";